import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";
import { ObjectTypeSysname } from "../types";
import { PropertyType, PropertyTypeSearchParams } from "../interfaces";

export const propertyTypesRoute = () =>
  buildUrl({
    url: `${baseUrl}/dict-api/property-types`,
  });

export const propertyTypeByObjectTypeRoute = (objectTypeSysname: ObjectTypeSysname) =>
  buildUrl({
    url: `${baseUrl}/dict-api/property-types/${objectTypeSysname}`,
  });

export const propertyTypeByTypeIdRoute = (props: {
  objectTypeSysname: ObjectTypeSysname;
  propertyTypeAlias: string;
}) => {
  const { objectTypeSysname, propertyTypeAlias } = props;
  return buildUrl({
    url: `${baseUrl}/dict-api/property-types/${objectTypeSysname}/${propertyTypeAlias}`,
  });
};

export const propertyTypesPageSearchRoute = (params: PropertyTypeSearchParams) =>
  buildUrl({
    url: `${baseUrl}/dict-api/property-types/pageable-search`,
    searchParams: { ...params },
  });
